import { render, staticRenderFns } from "./AvatarSelect.vue?vue&type=template&id=5f8a6ea4&scoped=true&"
import script from "./AvatarSelect.vue?vue&type=script&lang=ts&"
export * from "./AvatarSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarSelect.vue?vue&type=style&index=0&id=5f8a6ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a6ea4",
  null
  
)

export default component.exports